<div class="row">
  <div class="col-12 col-md-12">
    <section class="container-style">
      <div class="row">
        <form [formGroup]="formNoteStage">
          <div class="">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
                <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [icon]="'pi pi-plus'"
                  [width]="'5.5rem'" (onClick)="newNoteStage()"></app-custom-button>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-lg-1 col-md-2 col-sm-2 col-6">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Consecutivo'"
                  [required]="true"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-4 col-6">
                <app-custom-datepicker formControlName="dateMaintenanceOrderNote" [labelText]="'Fecha'"
                  [required]="true"></app-custom-datepicker>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <app-custom-select formControlName="conceptId" [labelText]="'Etapa'" [list]="listNoteStage"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-5 col-md-8 col-sm-10 col-12">
                <app-custom-textarea formControlName="annotation" [labelText]="'Anotación'" [rows]="1"
                  [maxLength]="1000"></app-custom-textarea>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-2 justify-content-end">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <section class="container-style mt-2">
      <div id="header-detail" class="d-flex flex-row justify-content-between"></div>
      <div class="pt-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
          <app-custom-table [headers]="header" [data]="detailData" [actions]="tableActions"
            (onPageChange)="onPageChange($event)" (onRecoverData)="getAllMaintenanceOrderNotesWithPagination()"
            (onAction)="onAction($event)">
          </app-custom-table>
        </div>
      </div>
    </section>
    <section>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2">
          <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
            (onClick)="close()"></app-custom-button>
        </div>
      </div>
    </section>
  </div>
</div>